import React from 'react'

import { theme } from 'styles/theme'
interface SVGProps {
  color?: string
  width?: string
  height?: string
}
const SparkleIcon = ({
  color = theme.palette.primary.main,
  height = '18',
  width = '19'
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11.6464 13.71L10.6762 16.7127L9.70592 13.71C9.24837 12.2904 8.13515 11.1772 6.71553 10.7196L3.71289 9.7494L6.71553 8.77916C8.13515 8.32161 9.24837 7.20839 9.70592 5.78877L10.6762 2.78613L11.6464 5.78877C12.1039 7.20839 13.2172 8.32161 14.6368 8.77916L17.6394 9.7494L14.6368 10.7196C13.2172 11.1772 12.106 12.2904 11.6464 13.71Z"
        fill={color}
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M4.25476 5.752L3.71347 7.42898L3.17218 5.752C2.94341 5.04321 2.38577 4.48558 1.67699 4.25681L0 3.71347L1.67699 3.17218C2.38577 2.94341 2.94341 2.38577 3.17218 1.67699L3.71347 0L4.25476 1.67699C4.48354 2.38577 5.04117 2.94341 5.74996 3.17218L7.42694 3.71347L5.74996 4.25476C5.04117 4.48558 4.48558 5.04117 4.25476 5.752Z"
        fill={color}
      />
    </svg>
  )
}

export default SparkleIcon
